interface IHPreparePropertyTitle {
  propertyType: string;
  sectorName: string;
  cityName: string;
  isProject?: boolean;
}
export const HPreparePropertyTitle = (arg: IHPreparePropertyTitle) => {
  return arg.isProject
    ? `Proyecto de ${arg.propertyType} en ${arg.sectorName} ${arg.cityName}`
    : `${arg.propertyType} en ${arg.sectorName} ${arg.cityName}`;
};
